import {
	Box,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
} from "@chakra-ui/react";
import PenIcon from "../icons/PenIcon";
import UserForm from "../forms/UserForm";
import { User } from "../../types/user.types";
import { useQueryClient } from "react-query";

const UserModal = ({
	isOpen,
	onClose,
	user,
}: {
	isOpen: boolean;
	onClose: () => void;
	user: User;
}) => {
	const queryClient = useQueryClient();
	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered>
			<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(6.9px)" />
			<ModalContent maxW={"none"} w="600px">
				<ModalHeader borderBottom="solid 1px #E2E8F0">
					<Flex>
						<Flex
							w="48px"
							h="48px"
							bg="zinc.50"
							border="solid 1px"
							borderColor="brand.100"
							justifyContent="center"
							alignItems="center"
							borderRadius={100}
							mr="8px"
						>
							<PenIcon w="24px" h="24px" color="brand.700"></PenIcon>
						</Flex>
						<Box lineHeight="48px">
							Editer les informations de l'utilisateur
						</Box>
					</Flex>
				</ModalHeader>
				<ModalCloseButton onClick={onClose} />
				<ModalBody>
					<UserForm
						user={user}
						onSuccess={() => {
							queryClient.invalidateQueries("users");
							onClose();
						}}
					/>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};

export default UserModal;
